/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import Texto from '@infotrack/presentacion-componentes/texto';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaDivisionesDocumentosDefectoVistaProps } from '../interfaces';
import { accionesDivisionesDefecto, columnasDivisionesDefecto, opcionesDivisionesDefecto } from './constantes';

const VistaDivisionesDocumentosDefecto: React.FunctionComponent<ITablaDivisionesDocumentosDefectoVistaProps &
    InjectedIntlProps> = ({
    divisionesDocumentosDefectos,
    cargarDivisionesDocumentosDefecto,
    confirmarEliminacion,
    intl,
    manejarFormulario,
    confirmarActivarDivisionDefecto,
}) => (
    <Tabla
        columns={columnasDivisionesDefecto(intl.formatMessage, confirmarActivarDivisionDefecto)}
        data={divisionesDocumentosDefectos}
        actions={accionesDivisionesDefecto(
            manejarFormulario,
            cargarDivisionesDocumentosDefecto,
            intl.formatMessage,
            confirmarEliminacion
        )}
        options={opcionesDivisionesDefecto}
        style={{ width: '100%' }}
    />
);

export default injectIntl(VistaDivisionesDocumentosDefecto);
